import { useNavigate } from 'react-router-dom';

export interface RelatedEntityNavigationExtra {
  productId?: number;
  locationId?: number;
  productCode?: string;
}

export const useRelatedEntityNavigation = () => {
  const navigate = useNavigate();

  const navigateToRelatedEntity = (
    type: string | undefined,
    id: number | undefined,
    code?: string | undefined,
    extra?: RelatedEntityNavigationExtra,
  ) => {
    if (!type) {
      console.warn('Tipo de entidad relacionada no disponible');
      return;
    }

    switch (type) {
      case 'SALES_ORDER':
        if (id == null) {
          console.warn('ID de orden no disponible');
          return;
        }
        navigate('/dashboard/orders', {
          state: { openOrderDetails: id },
        });
        break;

      case 'INVENTORY_TRANSFER':
        if (id == null) {
          console.warn('ID de transferencia no disponible');
          return;
        }
        navigate('/dashboard/inventory/transfer', {
          state: {
            openTransferDetails: id,
            ...(code ? { filterTransferCode: code } : {}),
          },
        });
        break;

      case 'INVENTORY_REQUEST':
        if (id == null) {
          console.warn('ID de solicitud no disponible');
          return;
        }
        navigate('/dashboard/inventory/requests', {
          state: {
            openRequestDetails: id,
            ...(code ? { filterRequestCode: code } : {}),
          },
        });
        break;

      case 'INVENTORY_RECORD':
        if (id == null) {
          console.warn('ID de registro no disponible');
          return;
        }
        navigate('/dashboard/inventory/register', {
          state: { openRecordDetails: id },
        });
        break;

      case 'SAFETY_STOCK': {
        const qs = new URLSearchParams();
        const pcode = extra?.productCode;
        const lid = extra?.locationId;
        if (pcode) qs.set('productCode', pcode);
        if (lid != null) qs.set('locationId', String(lid));
        const q = qs.toString();
        navigate(
          q ? `/dashboard/inventory/safety-stock?${q}` : '/dashboard/inventory/safety-stock',
        );
        break;
      }

      case 'SAFETY_STOCK_BULK':
      case 'SAFETY_STOCK_BULK_SELECTION': {
        const qs = new URLSearchParams();
        const lid = extra?.locationId;
        if (lid != null) qs.set('locationId', String(lid));
        const q = qs.toString();
        navigate(
          q ? `/dashboard/inventory/safety-stock?${q}` : '/dashboard/inventory/safety-stock',
        );
        break;
      }

      case 'PHYSICAL_COUNT':
        navigate('/dashboard/inventory/physical-count', {
          state: { openSessionDetails: id },
        });
        break;

      default:
        console.warn(`Tipo de entidad relacionada no soportado: ${type}`);
    }
  };

  return { navigateToRelatedEntity };
};
